module.exports = __webpack_public_path__ + "static/media/d3.23d925ff.jpg";